import React from 'react';

const About = () => {
    return (
        <div className='text-white bg-gradient-to-b from-[#0a0a16] to-[#131724] py-16' id='about'>
            <div className='max-w-[1200px] mx-auto px-4'>
                <div className='text-center mb-12'>
                    <h2 className='text-3xl md:text-4xl font-bold text-indigo-400 mb-4'>About</h2>
                    <div className='w-16 h-1 bg-indigo-500 mx-auto mb-8'></div>
                </div>
                
                <div className='grid md:grid-cols-2 gap-8 mb-16'>
                    <div className='bg-[#1d1c28] border border-indigo-500/30 rounded-xl p-6 shadow-lg transform transition-transform hover:scale-[1.02]'>
                        <div className='flex items-center mb-4'>
                            <div className='w-12 h-12 rounded-lg bg-red-500/10 flex items-center justify-center mr-4'>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            <h3 className='text-xl font-semibold text-red-400'>Turbulent Flow</h3>
                        </div>
                        <p className='text-gray-300 text-sm mb-4'>Chaotic, unpredictable movement with constant direction changes and energy loss. Like business processes that are inefficient and disorganized.</p>
                        <div className='w-full h-24 bg-[#0d0d1a] rounded-lg overflow-hidden flex items-center justify-center'>
                            <svg viewBox="0 0 200 50" className="w-full h-full">
                                <path d="M0,25 Q10,10 20,30 T40,15 T60,35 T80,5 T100,40 T120,20 T140,30 T160,10 T180,25 T200,15" fill="none" stroke="#ef4444" strokeWidth="2" />
                            </svg>
                        </div>
                    </div>
                    
                    <div className='bg-[#1d1c28] border border-indigo-500/30 rounded-xl p-6 shadow-lg transform transition-transform hover:scale-[1.02]'>
                        <div className='flex items-center mb-4'>
                            <div className='w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center mr-4'>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </div>
                            <h3 className='text-xl font-semibold text-blue-400'>Laminar Flow</h3>
                        </div>
                        <p className='text-gray-300 text-sm mb-4'>Smooth, organized flow with parallel streamlines and minimal energy dissipation. Like optimized business processes that are efficient and streamlined.</p>
                        <div className='w-full h-24 bg-[#0d0d1a] rounded-lg overflow-hidden flex items-center justify-center'>
                            <svg viewBox="0 0 200 50" className="w-full h-full">
                                <path d="M0,15 L200,15" fill="none" stroke="#3b82f6" strokeWidth="2" />
                                <path d="M0,25 L200,25" fill="none" stroke="#3b82f6" strokeWidth="2" />
                                <path d="M0,35 L200,35" fill="none" stroke="#3b82f6" strokeWidth="2" />
                            </svg>
                        </div>
                    </div>
                </div>
                
                <div className='text-center max-w-[800px] mx-auto'>
                    <p className='text-gray-300 text-base md:text-lg leading-relaxed'>
                        Laminar Innovation is a team of developers specialized in transforming chaotic business processes into streamlined, efficient solutions. We analyze your workflow, identify bottlenecks, and build custom software that optimizes your operations—allowing you to focus on growth. With expertise in full-stack development, we create seamless experiences from user interface to backend infrastructure.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;